export default {
    name: 'ToolDescriptionInput',
    inheritAttrs: false,
    props: [],
    data() {
        return {};
    },
    methods: {},
    async mounted() {
    }
};
